import { ActionIcon, Tooltip } from "@mantine/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { IconSpyOff } from "@tabler/icons-react";
import { useTRPC } from "@/common/utils/trpc";
import { listUserHistoryInfiniteQueryOptionsKey } from "../list-user-history/listUserHistoryInfiniteQueryOptions";

export function StopImpersonatingUserButton() {
	const trpc = useTRPC();
	const queryClient = useQueryClient();
	// const mutation = useMutation(stopImpersonatingUserMutationOptions(queryClient));
	const mutation = useMutation(
		trpc.users.stopImpersonatingUser.mutationOptions({
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: listUserHistoryInfiniteQueryOptionsKey(),
				});
				window.location.reload();
			},
			onError: (error) => {
				notifications.show({
					title: "Error",
					message: "Failed to stop impersonating user",
					color: "red",
				});
			},
		}),
	);

	return (
		<Tooltip label={"Stop Impersonating"}>
			<ActionIcon
				aria-label={"Stop Impersonating"}
				variant="subtle"
				size="xl"
				onClick={() => {
					mutation.mutate({});
				}}
				loading={mutation.isPending}
			>
				<IconSpyOff />
			</ActionIcon>
		</Tooltip>
	);
}
